import * as React from 'react';
import { IAsidePanelActionsButtonsGroupInheritedProps } from './types';

export function AsidePanelActionsButtonsGroup ({
    children,
    title,
}: IAsidePanelActionsButtonsGroupInheritedProps) {
    const className = 'aside-panel__actions-buttons-group';
    return (
        <div className={className}>
            {title && <span className={className + '-subtitle'}>{title}</span>}
            {children}
        </div>
    );
};
